export default {
  "home": "Home",
  "not_found": "Not Found",
  "greeting": "Hello",
}
